import './index.css'
import React from 'react'
import { connect } from 'react-redux'
import type {
  Campaign,
  CampaignFooter,
  CampaignFooterSnapshot,
  CampaignSection,
} from 'types/content-editor'
import { loadCampaignFooters } from '@disco/state-management/actions/campaign-footer-actions'
import {
  getCampaignBusinessAddress,
  getDefaultCampaignFooter,
} from '@disco/state-management/selectors/campaigns'
import { isDark } from '@disco/utils/color-utils'
import { sanitize } from '@disco/utils/string-utils'
import withData from 'hocs/with-data'

const mapStateToProps = (state, { footer, campaign }) => ({
  businessAddressMjml: getCampaignBusinessAddress(state, {
    campaignId: campaign?.id,
  }).business_address_mjml,
  footer: footer || getDefaultCampaignFooter(state),
  loaded: state.emailCampaigns.campaignFooters.loaded,
})

/*
const defaultColors = {
  facebook: '#3b5998',
  google: '#dc4e41',
  instagram: '#3f729b',
  linkedin: '#0077b5',
  pinterest: '#bd081c',
  twitter: '#55acee',
}
*/
const iconsAvailable = [
  'web',
  'twitter',
  'google',
  'instagram',
  'linkedin',
  'pinterest',
  'youtube',
  'facebook',
  'soundcloud',
  'apple',
  'spotify',
]
type Props = {
  footer: CampaignFooter | null | undefined
  businessAddressMjml: string
  section: CampaignSection
  snapshot: CampaignFooterSnapshot
  campaign: Campaign
}

const FooterBlock = ({
  footer,
  businessAddressMjml,
  section,
  snapshot,
  campaign,
}: Props) => {
  const linkStyle = section.color
    ? {
        color: section.color,
      }
    : null
  const backgroundColor = section.backgroundColor || '#fff'
  let socialIconSuffix = '-d'

  if (isDark(backgroundColor)) {
    socialIconSuffix = '-l'
  }

  let socialLinks = footer?.social_links ?? {}
  let footer_text_mjml = footer?.footer_text_mjml
  let business_address_mjml = businessAddressMjml

  if (campaign.status === 'sent' && snapshot) {
    socialLinks = snapshot.social_links
    footer_text_mjml = snapshot.footer_text_mjml
    business_address_mjml = snapshot.business_address_mjml
  }

  return (
    <div className="content-editor__footer-block">
      {socialLinks && (
        <div className="content-editor__footer-block__social">
          {Object.keys(socialLinks)
            .filter(
              key =>
                iconsAvailable.includes(key) &&
                socialLinks[key] &&
                socialLinks[key].trim().length > 0,
            )
            .map(key => {
              return (
                <a
                  key={key}
                  className="social"
                  href={socialLinks[key]}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={
                    {
                      // backgroundColor: '#515151', //defaultColors[key],
                    }
                  }
                  title={socialLinks[key]}
                >
                  <img
                    className="content-editor__footer-block__social__icon"
                    src={`https://static.disco.ac/campaign-editor/footer-r3/${key}${socialIconSuffix}-96.png`}
                    width="48"
                    height="48"
                  />
                </a>
              )
            })}
        </div>
      )}
      {footer_text_mjml && (
        <div
          className="content-editor__footer-block__text"
          dangerouslySetInnerHTML={{
            __html: sanitize(footer_text_mjml),
          }}
        />
      )}
      {business_address_mjml && (
        <div
          className="content-editor__footer-block__text content-editor__footer-block__text--small"
          dangerouslySetInnerHTML={{
            __html: sanitize(business_address_mjml),
          }}
        />
      )}
      <a
        className="content-editor__footer-block__unsubscribe"
        rel="noopener noreferrer"
        style={linkStyle}
      >
        Unsubscribe
      </a>
    </div>
  )
}

export default withData(
  () =>
    connect(mapStateToProps, {
      loadCampaignFooters,
    }),
  (loaderProps: Record<string, any>) => {
    const { footer, loaded, loadCampaignFooters } = loaderProps

    if (!footer && !loaded) {
      return loadCampaignFooters().then(() => Promise.resolve(null))
    }

    return Promise.resolve({
      footer,
    })
  },
)(FooterBlock) as any
